/*
 * Copyright (C) 2005 - 2023. Cloud Software Group, Inc. All Rights Reserved. Confidential & Proprietary.
 * Licensed pursuant to commercial Cloud Software Group, Inc. End User License Agreement.
 */

import datasetTypes from '../../enums/datasetTypes';
import GenericChartVisualization from './chart/GenericChartVisualization';
import genericChartVisualizationStaticPropertiesReducer from './chart/reducers/genericChartVisualizationReducer';

export class BarVisualization extends GenericChartVisualization {

    getChartSection() {
        const chart = super.getChartSection();

        return {
            ...chart,
            type: 'bar'
        };
    }

    getTooltipSection() {
        const tooltip = super.getTooltipSection();

        return {
            ...tooltip,
            followPointer: true
        }
    }

    generateXAxisLabelsSection() {
        const labels = super.generateXAxisLabelsSection();
        const formattingOptions = this.getFormattingOptions();

        // workaround for HC bug #2973, JS HC patch #16. Set y-axis labels align to the left. Because HC lib stops
        // calculating valid size for labels when they rotated for more than 74 degrees for bar chart
        let { align } = labels;
        if (Math.abs(formattingOptions.xAxisRotation) >= 75) {
            align = 'right';
        }

        return {
            ...labels,
            align,
            rotation: formattingOptions.yAxisRotation,
            step: formattingOptions.yAxisStep
        };
    }

    getXAxisSection(selectedRowIndex: number) {
        const section = super.getXAxisSection(selectedRowIndex);

        return {
            ...section,
            categories: this.getCategoriesFlat(selectedRowIndex)
        }
    }

    getYAxisSection() {
        const section = super.getYAxisSection();
        const formattingOptions = this.getFormattingOptions();

        return {
            ...section,
            labels: {
                ...section.labels,
                rotation: formattingOptions.xAxisRotation,
                step: formattingOptions.xAxisStep,
            }
        };
    }
}

export const BarVisualizationDescriptor = {
    legacyAdhoc: 'bar',
    parentClass: 'Bar',
    cssClass: 'Bar',
    bundleName: 'adhoc.visualisation.chooser.type.BAR',
    name: 'Bar',
    group: 'adhoc.visualisation.chooser.type.GROUP_COLUMN_AND_BAR',
    datasetType: datasetTypes.MULTI_AXIS,
    component: BarVisualization,
    staticPropertiesReducer: genericChartVisualizationStaticPropertiesReducer,
    requirements: {
        measures: { min: 1 },
        fields: { min: 0 }
    }
};
